import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { EligibiliteBeneficiaire } from 'src/app/shared/models/eligibiliteBeneficiaire';

@Component({
	selector: 'app-eligibiliteBeneficiaire-modal-ajout',
	templateUrl: './eligibiliteBeneficiaire-modal-ajout.component.html',
	styleUrls: ['./eligibiliteBeneficiaire-modal-ajout.component.scss']
})
export class EligibiliteBeneficiaireModalAjoutComponent {
	NAME_PATTERN = '^[^0-9]+$';

	formEdit = new FormGroup({
		name: new FormControl('', [
			Validators.required
		])
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = false;

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private logger: LogService
	) {}

	// ngOnInit(): void {}

	onSubmit() {
		this.isValidateButtonClicked = true;
		const eligibiliteBeneficiaire = new EligibiliteBeneficiaire();
		eligibiliteBeneficiaire.name = this.formEdit.get('name').value;
		this.facade.eligibiliteBeneficiaireService.addEligibiliteBeneficiaire(eligibiliteBeneficiaire).subscribe({
			next: (succ) => {
				this.bsModalRef.hide();
				// this.isValidateButtonClicked=false;
			},
			error: (err) => {
				this.isValidateButtonClicked = false;
				this.facade.toastService.createHttpErrorToast(
					err.error.message ? err.error.message : '',
					err.status
				);
				this.logger.error(err);
			}
		});
	}

	get name() {
		return this.formEdit.get('name');
	}
}
